import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { listOrder, deleteOrder } from '../../actions/orderActions';
import Axios from '../../axios/axios';
import { dateFormate } from '../../utils';

export default function PendingReturn() {
  const dispatch = useDispatch();
  const [dataList, setDataList] = useState([]);

  const orderList_ = useSelector((state) => state.orderList);
  const { orders } = orderList_;


  useEffect(() => {
    getDataFromApi();
  }, []);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  const getDataFromApi = async () => {
    const data = await Axios.get(`/api/order/return-item/list`);

    setDataList(data?.data?.array);
  };

  console.log(dataList);

  const deleteHandler = (id) => {
    if (window.confirm('Are you sure')) {
      dispatch(deleteOrder(id));
      window.location.reload();
    }
  };

  const search = (e) => {
    if (e.keyCode === 13) {
      let obj = {
        phone: parseInt(e.target.value),
        isNotDelivered: true,
      };
      dispatch(listOrder(obj));
    }
  };

  const editOrder = async (id) => {
    const data = await Axios.get(`/api/order/transaction/${id}`);

    if (data.data === 1) {
      window.location.href = `/order/edit/${id}`;
    } else {
      alert('Cant edit order!');
    }
  };

  const getDelivered = (order) => {
    let result = order?.orderItems?.some((data) => data.isDelivered === false);

    return result;
  };

  const getReturn = (order) => {
    let result = order?.orderItems?.some((data) => data.isReturn === false);

    return result;
  };

  // FIX: Calculate the correct order total from order items
  const calculateOrderTotal = (order) => {
    if (!order?.orderItems || order.orderItems.length === 0) {
      return order?.orderAmount || 0;
    }
    
    // Calculate total from order items
    const itemsTotal = order.orderItems.reduce((total, item) => {
      // Calculate: price * quantity * days
      const itemTotal = (item.price || 0) * (item.qty || 1) * (item.days || 1);
      return total + itemTotal;
    }, 0);
    
    // If itemsTotal is valid, use it; otherwise fall back to orderAmount
    return itemsTotal > 0 ? itemsTotal : (order?.orderAmount || 0);
  };

  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              {/* <div class="p-2"> */}
                {/* {' '} */}
                <h4 class="card-title">Pending Return List </h4>
              {/* </div> */}

              <div class="ml-auto p-2">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search Number here..."
                  onKeyDown={(e) => search(e)}
                />
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>Date</th>
                    <th>Order Id</th>
                    <th>Customer Name</th>
                    <th>Delivered</th>
                    <th>Return</th>
                    <th>Amount</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {dataList?.length > 0 ? (
                    dataList?.map((order,index) => (
                      <tr>
                        <td>{index+1}</td>
                        <td>{dateFormate(order?.createdAt)}</td>
                        <td>
                          <Link to={`/order/${order._id}`}>
                            ADC_{order?.orderId}
                          </Link>
                        </td>
                        <td>
                          <b>{order?.user?.name}</b> <br />{' '}
                          <div className="mt-2">{order?.user?.phone1}</div>
                        </td>

                        <td>
                          {getDelivered(order) === false ? (
                            <i
                              class="icon-check menu-icon"
                              style={{ fontSize: '20px' }}
                            ></i>
                          ) : (
                            'No'
                          )}
                        </td>
                        <td>
                          {' '}
                          {getReturn(order) === false ? (
                            <i
                              class="icon-check menu-icon"
                              style={{ fontSize: '20px' }}
                            ></i>
                          ) : (
                            'No'
                          )}
                        </td>
                        <td>₹ {calculateOrderTotal(order)}</td>
                        <td>
                          <div class="d-flex flex-row">
                            <div class="p-2">
                              {' '}
                              {/* <Link to={`/order/edit/${order?._id}`}> */}
                              {/* <button
                                type="button"
                                class="btn btn-outline-dark btn-sm"
                                onClick={(e) => editOrder(order?._id)}
                              >
                                Edit
                              </button> */}
                              {/* </Link> */}
                            </div>
                            <div class="p-2">
                              {' '}
                              {/* <button
                                type="button"
                                class="btn btn-outline-danger btn-sm"
                                onClick={() => deleteHandler(order?._id)}
                              >
                                Delete
                              </button> */}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>No Order found on this number</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}